import ReactPhoneInput from 'react-phone-number-input';

import styled from 'styled-components';

const PhoneContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: none;
  height: 48px;
  width: 100%;
  padding-bottom: 100px;
`;

const Label = styled.label`
  color: ${(props) =>
    props.error ? props.theme.COLOR_ERROR_TEXT : props.theme.COLOR_GREY_TEXT};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.4px;
  margin-top: 12px;
  margin-bottom: 4px;
`;

const PhoneInput = styled(ReactPhoneInput)`
  &:focus-within {
    .PhoneInputInput,
    .PhoneInputCountry {
      border-color: ${({ theme }) => theme.COLOR_BLACK};
    }
  }
  .PhoneInputInput {
    height: 49px;
    border-radius: 0px 4px 4px 0px;
    border: 1px solid
      ${(props) =>
        props.errorMessage
          ? props.theme.COLOR_ERROR_TEXT
          : props.theme.COLOR_GREY5};
    padding-left: 10px;
    outline: 0;
    font-size: 14px;
  }

  .PhoneInput-color--focus {
    border-color: #eaedf3;
  }

  .PhoneInputCountryIconImg {
    border-radius: 4px;
  }

  .PhoneInputCountryIcon--border {
    border: none;
    border-radius: 4px;
    background-color: #eaedf3;
  }

  .PhoneInputCountry {
    display: flex;
    justify-content: center;
    border-radius: 4px 0 0 4px;
    width: 67px;
    margin: 0;
    border: 1px solid
      ${(props) =>
        props.errorMessage
          ? props.theme.COLOR_ERROR_TEXT
          : props.theme.COLOR_GREY5};
    border-right: none;
    font-size: 14px;
  }
`;

const StyledPhoneInput = {
  PhoneContainer,
  PhoneInput,
  Label,
};

export default StyledPhoneInput;
